export default {
    currentDragCube: null,
    globalEventIsBind: false,
    dragTransferIsInital: false,
    dragStatus: 'over',
    dragStartX: 0,
    dragStartY: 0
};
